import qs from "query-string";
import { v4 as uuid } from "uuid";
import Cookies from "js-cookie";
import { captureException } from "@lululemon/mwa-utils";

export function getSessionId() {
  let sessionId = Cookies.get("lll-ecom-correlation-id") || "";
  try {
    if (!sessionId) {
      sessionId = uuid();
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return sessionId;
}

export function getEcId() {
  let ecid = Cookies.get("s_ecid") || "";
  try {
    if (!ecid && process.browser) {
      if (process.env.NODE_ENV === "development") {
        ecid = window?._satellite
          ?.getVisitorId?.()
          ?.getMarketingCloudVisitorID();
      } else {
        // eslint-disable-next-line no-underscore-dangle
        ecid = window._satellite.getVisitorId().getMarketingCloudVisitorID();
      }
    }
  } catch (e) {
    captureException(e, "warning", { tags: { isThirdParty: true } });
  }
  return ecid;
}

export function getMCId(searchStr) {
  return qs.parse(searchStr).mcid;
}

/**
 * Return an EcId without the prefix deliminted by a pipe. (MCMID|123456789)
 * @param {string} ecId
 * @returns {string} right half of the split ecId
 */
export function getSanitizedEcId(ecId) {
  const splitEcId = ecId?.split("|");
  return splitEcId?.length > 0 ? splitEcId[splitEcId.length - 1] : "";
}
